import type {
  AuthSessionFlowEvent,
  AuthSessionFlowTrace,
  AuthSessionStatus,
  EnsureSessionReason,
  SessionFallbackMode,
} from './types';

let authSessionFlowCounter = 0;

const getEventForReason = (reason: EnsureSessionReason): AuthSessionFlowEvent => {
  switch (reason) {
    case 'app-start':
      return 'APP_START';
    case 'auth-callback':
      return 'AUTH_CALLBACK';
    case 'bootstrap':
      return 'SELECT_ORGANIZATION';
    case 'manual-refresh':
      return 'MANUAL_REFRESH';
    case 'request':
    default:
      return 'REQUEST_SESSION';
  }
};

export const createAuthSessionFlowTrace = ({
  reason,
  targetOrganizationId,
  fallbackMode,
  attempt,
  flowId,
}: {
  reason: EnsureSessionReason;
  targetOrganizationId: string | null;
  fallbackMode: SessionFallbackMode;
  attempt?: number;
  flowId?: string;
}): AuthSessionFlowTrace => {
  const resolvedFlowId = flowId ?? `auth-flow-${Date.now()}-${++authSessionFlowCounter}`;

  return {
    flowId: resolvedFlowId,
    event: getEventForReason(reason),
    reason,
    targetOrganizationId,
    fallbackMode,
    ...(attempt !== undefined ? { attempt } : {}),
  };
};

export const logAuthSessionFlow = (
  level: 'debug' | 'warn',
  message: string,
  trace: AuthSessionFlowTrace,
  payload?: {
    stage?: AuthSessionStatus;
    outcome?: string;
    failureReason?: string;
    maxAttempts?: number;
    hasCommittedSession?: boolean;
    hasLocalSession?: boolean;
    currentOrganizationId?: string | null;
    targetOrganizationId?: string | null;
    organizationId?: string | null;
    selectedOrganizationId?: string | null;
    resolvedOrganizationId?: string | null;
    organizationCount?: number;
    error?: unknown;
  },
) => {
  console[level]('[AuthSessionStore] ' + message, {
    flowId: trace.flowId,
    event: trace.event,
    reason: trace.reason,
    fallbackMode: trace.fallbackMode,
    targetOrganizationId: trace.targetOrganizationId,
    attempt: trace.attempt ?? null,
    ...payload,
  });
};
